import { createAction } from '@reduxjs/toolkit';
export const DELETE_ANALYTIC_TEAM = 'DELETE_ANALYTIC_TEAM';
export const deleteAnalyticTeamAction = createAction(DELETE_ANALYTIC_TEAM);